export class S3RestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "prefix",
            "baseName": "prefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return S3RestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
